export default __webpack_public_path__ + "9d6835eb6eb9460737a7317b4a59bb5e.png";